import React, {useMemo, useState} from "react";
import PropTypes from "prop-types";
import {appConfig} from "config/defaultConfig";
import {t} from "i18next";

const {ROUTES} = appConfig.APP;

export const IncidentDetailContext = React.createContext({
  activeTab: {},
  editableTitleId: "",
  tabData: {},
  changeEditableTitleId: () => {},
  setActiveTab: () => {}
});

export const IncidentDetailProvider = (props) => {
  const {children} = props;

  const tabData = useMemo(
    () => [
      {
        title: t("incidentDetail.tabTitle.overview"),
        route: ROUTES.INCIDENT_DETAIL.OVERVIEW
      },
      {
        title: t("incidentDetail.tabTitle.detection"),
        route: ROUTES.INCIDENT_DETAIL.DETECTION
      },
      {
        title: t("incidentDetail.tabTitle.response"),
        route: ROUTES.INCIDENT_DETAIL.RESPONSE
      },
      {
        title: t("incidentDetail.tabTitle.worklog"),
        route: ROUTES.INCIDENT_DETAIL.WORKLOG
      }
    ],
    []
  );

  const [activeTab, setActiveTab] = useState(tabData[0]);
  const [editableTitleId, setEditableTitleId] = useState("");

  // Auto sets editable title for incident in incident detail
  const changeEditableTitleId = (incidentId) => {
    setEditableTitleId(incidentId);
  };

  return (
    <IncidentDetailContext.Provider
      value={{
        activeTab,
        editableTitleId,
        tabData,
        changeEditableTitleId,
        setActiveTab
      }}>
      {children}
    </IncidentDetailContext.Provider>
  );
};

IncidentDetailProvider.propTypes = {
  children: PropTypes.any
};
